import type { FullPostType, SharingModalFactoryProps } from './types';

type Fn = () => void; // Temporary type

// Note: The following constants are exported for testing purposes only, they should not be used directly.

export const PRIMARY_ACTIONS: Record<FullPostType, Fn> = {
	facebook_post: () => {},
	facebook_group_post: () => {},
	facebook_story: () => {},
	instagram_post: () => {},
	instagram_story: () => {},
	reddit_post: () => {},
	reddit_group_post: () => {},
};

export const SECONDARY_ACTIONS: Record<FullPostType, Fn | undefined> = {
	facebook_post: undefined,
	facebook_group_post: () => {},
	facebook_story: undefined,
	instagram_post: undefined,
	instagram_story: undefined,
	reddit_post: undefined,
	reddit_group_post: () => {},
};

type ActionsFactoryType = {
	primaryAction: () => void;
	secondaryAction: (() => void) | undefined;
};

export function actionsFactory(props: SharingModalFactoryProps): ActionsFactoryType {
	let recommendedGroup;
	const { platform, postType } = props;

	if ('recommendedGroup' in props) {
		recommendedGroup = props.recommendedGroup;
	}

	const fullPostType = `${platform}${recommendedGroup ? '_group' : ''}_${postType}` as FullPostType;

	return {
		primaryAction: PRIMARY_ACTIONS[fullPostType],
		secondaryAction: SECONDARY_ACTIONS[fullPostType],
	};
}
